import { render, staticRenderFns } from "./CorporationJ.vue?vue&type=template&id=ea564df4&scoped=true"
import script from "./CorporationJ.vue?vue&type=script&lang=js"
export * from "./CorporationJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea564df4",
  null
  
)

export default component.exports